/**
 * @author Ketan Shetye
 * @created 2025-10-09
 * @description centralised exports for images, svgs, logos, ets
 */

export const Images = {
  dummyProfilePic: 'assets/images/dummy-profile-pic/dummy-profile-pic.png',
  dummyTownSeal: 'assets/images/town-seal/dummy-town-seal.png',
  geoPermitsLogo: 'assets/images/geopermits-logo/geopermits-logo.png',
  geoPermitsLogoWhiteBg: 'assets/images/geopermits-logo/geopermits-logo-white-bg.png',
  anytownSeal: 'assets/images/town-seal/anytown-seal.png',
  placeholderSeal: 'assets/images/placeholder-logo/placeholder-logo.png' //code added by Sanchit on 03/18/2026
};

export const svgs = {
  // in case of custom svg key and name must be same here key = dogIcon and name = dogIcon
  dogIcon: {
    fromMaterial: false,
    path: 'assets/svgs/dog-icon.svg',
    name: 'dogIcon'
  },
  // in case of material provided icon name plays very important role and it must same as material icon name here eg:- name=home
  homeIcon: { fromMaterial: true, path: '', name: 'home' },
  relateToPermitIcon: {
    fromMaterial: false,
    path: 'assets/svgs/relate-to-permit.svg',
    name: 'relateToPermitIcon'
  },

  // [START] 04-11-2025
  // Author: Furkan Khan
  // -------------------
  settingsIcon: { fromMaterial: true, path: '', name: 'settings' },
  logoutIcon: { fromMaterial: true, path: '', name: 'logout' },
  changeEmailIcon: { fromMaterial: true, path: '', name: 'alternate_email' },
  profileIcon: { fromMaterial: true, path: '', name: 'account_circle' },
  // -------------------
  // [END] - 04-11-2025
  keyboardArrowDownIcon: {
    fromMaterial: true,
    path: '',
    name: 'keyboard_arrow_down'
  },
  // [START] 11-11-2025
  // Author: Furkan Khan
  // -------------------
  waitingApprovalIcon: { fromMaterial: true, path: '', name: 'pending_actions' },
  feesIcon: { fromMaterial: true, path: '', name: 'payments' },
  inspectionIcon: { fromMaterial: true, path: '', name: 'visibility' },
  licenseIcon: { fromMaterial: true, path: '', name: 'credit_card_clock' },
  chatIcon: { fromMaterial: true, path: '', name: 'chat' },
  plumbingIcon: { fromMaterial: true, path: '', name: 'home_work' },
  //----------------
  //[END] 11-11-2025

  // [START] 18-11-2025
  // Author: Furkan Khan
  // -------------------
  searchIcon: { fromMaterial: true, path: '', name: 'search' },
  downArrowIcon: { fromMaterial: true, path: '', name: 'keyboard_arrow_down' },
  //----------------
  //[END] 18-11-2025


  // [START] 26-11-2025
  // Author: Furkan Khan
  // -------------------
  sortIcon: { fromMaterial: true, path: '', name: 'arrow_upward' },
  //----------------
  //[END] 26-11-2025

  //[START] by priya 17-11-2025
  hamburgerIcon: { fromMaterial: true, path: '', name: 'menu' },
  //[END] by priya 17-11-2025

  //[START] by Furkan 02-12-2025
  kebabMenuIcon: { fromMaterial: true, path: '', name: 'more_vert' },
  //[END] by Furkan 02-12-2025
  errorIcon: { fromMaterial: true, path: '', name: 'error' },
  chatStaffIcon: { fromMaterial: false, path: 'assets/svgs/dog-icon.svg', name: 'chatStaffIcon' },
  keyboardUpArrowIcon: { fromMaterial: true, path: '', name: 'keyboard_arrow_up' },
  //added by priya 15-01-2026
  fileUploadIcon: { fromMaterial: true, path: '', name: 'upload_file' },
  imageIcon: { fromMaterial: true, path: '', name: 'image' },
  deleteIcon: { fromMaterial: true, path: '', name: 'delete' },
  articleIcon: { fromMaterial: true, path: '', name: 'article' },
  pdfIcon: { fromMaterial: true, path: '', name: 'article' },
  //end  by priya 15-01-2026
  closeIcon : { fromMaterial: true, path: '', name: 'close' },//added by priya 21-01-2026
descriptionIcon:{fromMaterial: true, path: '', name: 'description'}, //added by priya 23-01-2026
  note_altIcon: { fromMaterial: true, path: '', name: 'note_alt' },//added by omkar 13-02-2026
  editIcon: { fromMaterial: true, path: '', name: 'edit' },//added by omkar 13-02-2026
  printIcon: { fromMaterial: true, path: '', name: 'print' },//added by ketan 18-02-2026
  applicationWorkflowIcon: { fromMaterial: true, path: '', name: 'account_tree' },//workflow-builder / app-version viewer entry
arrowDropUpIcon: { fromMaterial: true,  path: '', name: 'arrow_drop_up' }, //added by krutika on 13-03-2026
arrowUpwardIcon: { fromMaterial: true,  path: '', name: 'arrow_upward' }, //added by priya on 07-04-2026
arrowLeftIcon:{fromMaterial: true,  path: '', name: 'keyboard_backspace'},//added by priya on 14-04-2026
deleteOutlineIcon:{  fromMaterial: false, path: 'assets/svgs/delete-icon.svg', name: 'deleteOutlineIcon' },
warningAmberIcon:{fromMaterial: true,  path: '', name: 'warning_amber'},//added by priya on 11-06-2026
deleteAttachmentOutlineIcon:{  fromMaterial: false, path: 'assets/svgs/delete-attachment-icon.svg', name: 'deleteAttachmentOutlineIcon' },//added by priya on 17-06-2026
driveIcon:{fromMaterial: true,  path: '', name: 'insert_drive_file'},//added by priya on 17-06-2026
infoIcon:{fromMaterial: true,  path: '', name: 'info'},//added by priya on 23-06-2026
infoOutlinedIcon:{fromMaterial: false,  path: 'assets/svgs/info-outline-icon.svg', name: 'infoOutlinedIcon'},//added by priya on 16-07-2026
signOffDatatableIcon:{fromMaterial: false,  path: 'assets/svgs/signOffDatatableIcon.svg', name: 'signOffDatatableIcon'},//added by Sanchit on 04-08-2026
feesDatatableIcon:{fromMaterial: false,  path: 'assets/svgs/feesDatatableIcon.svg', name: 'feesDatatableIcon'},//added by Sanchit on 04-08-2026
inspectionDatatableIcon:{fromMaterial: false,  path: 'assets/svgs/inspectionDatatableIcon.svg', name: 'inspectionDatatableIcon'},//added by Sanchit on 04-08-2026
};

